import { CONTRACT } from "./action";

const initialState = {
  commodityList: [],
  suggestedCounterPart: [],
  suggestedExternalOptions: { ticket: [], contract: [] },
  suggestedInternalOptions: { ticket: [], contract: [] },
  searchTerm: ""
};

export function contractReducer(state = initialState, action) {
  switch (action.type) {
    case CONTRACT.create.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        contractCreated: action.data
      });
    case CONTRACT.create.error:
      return Object.assign({}, state, {
        fetchingComplete: true,
        contractCreated: action.data
      });
    case CONTRACT.edit.success:
      return Object.assign({}, state, {
        ContractUpdated: action.data
      });
    case CONTRACT.edit.selected:
      return Object.assign({}, state, {
        EditSelectedContract: action.data
      });
    case CONTRACT.delete.success:
      const contractId = action.data.data.id;
      return Object.assign({}, state, {
        ContractList: state.ContractList.filter(
          ContractList => ContractList.id !== contractId
        )
      });
    case CONTRACT.getALlCommodityList.success:
      return Object.assign({}, state, {
        commodityList: action.data.data
      });
    case CONTRACT.getCommodityVariertyList.success:
      return Object.assign({}, state, {
        commodityVarietyList: action.data,
        suggestedVariety: action.suggestedData
      });
    case CONTRACT.getAllCounterpartList.success:
      return Object.assign({}, state, {
        CounterPart: action.data,
        suggestedCounterPart: action.suggestedData
      });
    case CONTRACT.getAllContractStageList.success:
      return Object.assign({}, state, {
        ContractStageList: action.data
      });
    case CONTRACT.getAllContractTypeList.success:
      return Object.assign({}, state, {
        ContractTypeList: action.data
      });
    case CONTRACT.getAllContractsList.success:
      return Object.assign({}, state, {
        ContractList: action.data,
        suggestedContracts: action.suggestedData,
        contractCreated: {},
        ContractUpdated: {}
      });
    case CONTRACT.getContractsList.start:
      return Object.assign({}, state, {
        fetchingComplete: false,
        ContractList: [],
        contractCreated: {},
        ContractUpdated: {}
      });
    case CONTRACT.getContractsList.success:
      return Object.assign({}, state, {
        fetchingComplete: true,
        ContractList: action.data.data,
        pageCount: action.data.totalPages,
        totalElements: action.data.totalElements,
        contractCreated: {},
        ContractUpdated: {}
      });
    case CONTRACT.getDestinationByType.success:
      return Object.assign({}, state, {
        DestinationList: action.data,
        suggestedExternalOptions: action.suggestedData
      });
    case CONTRACT.InternalDestinationList.success:
      return Object.assign({}, state, {
        InternalDestinationList: action.data,
        suggestedInternalOptions: action.suggestedData
      });
    case CONTRACT.selectedContractDetails.success:
      return Object.assign({}, state, {
        selectedContractDetails: action.data
      });
    case CONTRACT.setSearchTerm.success:
      return {
        ...state,
        searchTerm: action.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/contract/reducer.js